module.exports = __webpack_public_path__ + "img/2Y.1.afe72e1e.jpg";